import Vue from "vue";
import auditService from "../../services/audit/audit";
import { Audit } from "../../services/audit/entities/audit.interface";
import { AuditState } from "./states/audit.state.interface";

export default {
  namespaced: true,
  state: {
    audit: [],
    totalAudits: 0
  },
  getters: {
    getAudit: (state: AuditState) => state.audit,
    getTotalAudits: (state: AuditState) => state.totalAudits
  },
  mutations: {
    setAudit(state: AuditState, audit: Array<Audit>) {
      Vue.set(state, "audit", audit);
    },
    setTotalAudits(state: AuditState, totalAudits: number) {
      Vue.set(state, "totalAudits", totalAudits);
    }
  },
  actions: {
    getAudit: async (context: any, payload: any) => {
      await auditService.getAudit(payload).then((response: any) => {
        context.commit("setTotalAudits", response.data.totalAudits);
        context.commit("setAudit", response.data.audits);
      });
    }
  }
};
